/**
 * App
 * Using pageName, which is variable in the state, to switch component
 * contact Page content: contactUs, callUs, email
 */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Helper
import { contactPage } from '../constants/UtilVariables';
import { trackPage, trackSetUp } from '../../lib/analytics-helper';
import Page from '../../lib/page';

// Components
import ContactUs from '../components/ContactUs';
import QuickAnswer from './QuickAnswer';
import HelpTemplate from '../components/HelpTemplate';
import ContactService from '../components/ContactService';
import AlertsContainer from './Alerts';
import Notifier from './Notifier';
import EmailNoIntent from './EmailNoIntent';
import ContactDialing from '../components/ContactDialing';
import { CALLUS_ELMO_TREATMENTS } from '../constants/PropTypesShapes';
import QualtricsFeedbackComponent from '../../common/QualtricsFeedbackComponent';
import EmailWebformNoTCode from './EmailWebformNoTCode';

const App = function (props) {
  const { callUsElmoTreatments, kanaCode, topicTreeLayer, topicsDisplay } = props;
  // To switch Channel Steering main content
  function getPageContent({ pageName }) {
    switch (pageName) {
      case contactPage.callUs: {
        Page.scrollToTop();
        // New Call us page redirect with Modal Container handling Email page redirection
        return (
          <div>
            <AlertsContainer />
            <ContactDialing callUsElmoTreatments={callUsElmoTreatments} />
            <QualtricsFeedbackComponent />
          </div>
        );
      }
      // TODO: Add Email Page content
      case contactPage.email:
        // Send FPTI impression event after receive topic data
        return (
          <div>
            <ContactService
              leftPanel={<EmailNoIntent />}
              rightPanel={<QuickAnswer pageName={pageName} />}
              kanaCode={kanaCode}
            />
          </div>
        );
      case contactPage.success:
        return (
          <div>
            <AlertsContainer />
            <Notifier />
          </div>
        );
      case contactPage.contactUs: {
        // Contact us im event needs to be fired only for default page
        if (topicTreeLayer === 1 && topicsDisplay) {
          trackSetUp({ id: 'contactUsPage', link: 'smarthelp-contact-us' });
        }

        // For displaying qualtrics only in default and final intent page
        const display = topicTreeLayer === 1 || !topicsDisplay;
        return <ContactUs display={display} />;
      }
      case contactPage.emailNoTCode: {
        trackPage({ id: 'complaintsWebformShown', link: 'smarthelp-complaints-webform-page' });
        let complaintReasonQuery = '';
        try {
          // parsing for complaint_reason query value in the url,
          // and complaint_reason dropdown value in complaints webform page will be auto selected based on value
          const queryParams = window.location.search || '';

          if (
            queryParams &&
            Array.isArray(queryParams.split('=')) &&
            queryParams.split('=')[0] === '?complaint_reason'
          ) {
            if (queryParams.split('=')[1] && Array.isArray(queryParams.split('=')[1].split('&'))) {
              complaintReasonQuery = queryParams.split('=')[1].split('&')[0];
            }
          }
        } catch (e) {
          complaintReasonQuery = '';
        }
        return <EmailWebformNoTCode complaintReasonQuery={complaintReasonQuery} />;
      }
      default: {
        return null;
      }
    }
  }

  // The main body content has tree different types: EMAIL/CALLUS/CONTACTUS
  const bodyContent = getPageContent({ pageName: props.pageName });

  return <HelpTemplate>{bodyContent}</HelpTemplate>;
};

function mapStateToProps(state) {
  return {
    pageName: state.location.pageName,
    callUsElmoTreatments: state.callUs.callUsElmoTreatments,
    kanaCode: state.emailNoIntent.kanaCode,
    topicTreeLayer: state.topicSelect.layer, // should be one
    topicsDisplay: state.selectResult.topicsDisplay,
  };
}

// App propTypes
App.propTypes = {
  pageName: PropTypes.string.isRequired,
  callUsElmoTreatments: PropTypes.arrayOf(PropTypes.shape(CALLUS_ELMO_TREATMENTS)),
  kanaCode: PropTypes.string.isRequired,
  topicTreeLayer: PropTypes.number,
  topicsDisplay: PropTypes.bool,
};

App.defaultProps = {
  callUsElmoTreatments: [],
};

export default connect(mapStateToProps)(App);
